import { render, staticRenderFns } from "./LsvaTrip.vue?vue&type=template&id=7bf1707e&scoped=true&"
import script from "./LsvaTrip.vue?vue&type=script&lang=js&"
export * from "./LsvaTrip.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTrip.vue?vue&type=style&index=0&id=7bf1707e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1707e",
  null
  
)

/* custom blocks */
import block0 from "./LsvaTrip.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports